import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "border rounded-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-black" }, "Dias da semana")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-black" }, "Turno")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-black" }, "Posições")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-black" }, "Time")
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-black" }, "Formação", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "w-full flex flex-wrap justify-end items-center gap-4 border-t py-4" }
const _hoisted_10 = { class: "flex items-center gap-2 min-w-[220px]" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-gray-900 whitespace-nowrap" }, "Modalidade de repasse:", -1)
const _hoisted_12 = {
  key: 0,
  class: "flex items-center gap-2 min-w-[260px]"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-gray-900 whitespace-nowrap" }, "Regra para antecipação:", -1)
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-gray-900 whitespace-nowrap" }, "Valor por hora:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-bold mr-1" }, "R$", -1)
const _hoisted_17 = ["data-testid"]

import { computed } from 'vue'
import DsMultipleSelect from '@/components/designSystem/Select/DsMultipleSelect.vue'
import EmptyList from '@/components/EmptyList.vue'
import { mdiTrashCan, mdiContentCopy } from '@mdi/js'
import { Item, ItemTeams, PaymentRule } from '@/pinia-store/useCreateScheduleStore'
import { ANTECIPE_RULE_DEFAULT, antecipeRuleOptions } from './antecipeRule'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentPolicyRulesTable',
  props: {
    rules: {},
    shifts: {},
    positions: {},
    teams: {},
    days: {},
    formations: {},
    formationRequired: { type: Boolean },
    repassModes: {},
    confirmDelete: { type: Function },
    copyRule: { type: Function },
    errors: {},
    showAntecipeRule: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const shouldShowFormation = computed(() => props.formationRequired === true)

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rules.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: _normalizeClass(['grid gap-4 px-4 p-3', shouldShowFormation.value ? 'md:grid-cols-5' : 'md:grid-cols-4'])
          }, [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            (shouldShowFormation.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true)
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "mb-2 px-4 border-t"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['grid gap-4 my-3', shouldShowFormation.value ? 'md:grid-cols-5' : 'md:grid-cols-4'])
              }, [
                _createVNode(DsMultipleSelect, {
                  modelValue: rule.days,
                  "onUpdate:modelValue": ($event: any) => ((rule.days) = $event),
                  items: _ctx.days,
                  error: !!_ctx.errors?.[`rules[${index}].days`],
                  "error-message": _ctx.errors?.[`rules[${index}].days`]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error", "error-message"]),
                _createVNode(DsMultipleSelect, {
                  modelValue: rule.shifts,
                  "onUpdate:modelValue": ($event: any) => ((rule.shifts) = $event),
                  items: _ctx.shifts,
                  error: !!_ctx.errors?.[`rules[${index}].shifts`],
                  "error-message": _ctx.errors?.[`rules[${index}].shifts`]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error", "error-message"]),
                _createVNode(DsMultipleSelect, {
                  modelValue: rule.positions,
                  "onUpdate:modelValue": ($event: any) => ((rule.positions) = $event),
                  items: _ctx.positions,
                  error: !!_ctx.errors?.[`rules[${index}].positions`],
                  "error-message": _ctx.errors?.[`rules[${index}].positions`]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error", "error-message"]),
                _createVNode(DsMultipleSelect, {
                  modelValue: rule.teams,
                  "onUpdate:modelValue": ($event: any) => ((rule.teams) = $event),
                  items: _ctx.teams,
                  error: !!_ctx.errors?.[`rules[${index}].teams`],
                  "error-message": _ctx.errors?.[`rules[${index}].teams`]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error", "error-message"]),
                (shouldShowFormation.value)
                  ? (_openBlock(), _createBlock(DsMultipleSelect, {
                      key: 0,
                      modelValue: rule.formations,
                      "onUpdate:modelValue": ($event: any) => ((rule.formations) = $event),
                      items: _ctx.formations
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_v_autocomplete, {
                    modelValue: rule.repassMode,
                    "onUpdate:modelValue": ($event: any) => ((rule.repassMode) = $event),
                    items: _ctx.repassModes,
                    "item-title": "label",
                    "item-value": "value",
                    density: "comfortable",
                    variant: "outlined",
                    "hide-details": "auto",
                    class: "w-full min-w-[128px]",
                    color: "primary",
                    error: !!_ctx.errors?.[`rules[${index}].repassMode`],
                    "error-messages": _ctx.errors?.[`rules[${index}].repassMode`]
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "error", "error-messages"])
                ]),
                (_ctx.showAntecipeRule)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_v_autocomplete, {
                        "model-value": rule.antecipeRule ?? _unref(ANTECIPE_RULE_DEFAULT),
                        items: _unref(antecipeRuleOptions),
                        "item-title": "title",
                        "item-value": "value",
                        density: "comfortable",
                        variant: "outlined",
                        "hide-details": "auto",
                        class: "w-full min-w-[220px]",
                        color: "primary",
                        "data-testid": `payment-rule-antecipe-rule-${index}`,
                        "onUpdate:modelValue": ($event: any) => (rule.antecipeRule = $event)
                      }, null, 8, ["model-value", "items", "data-testid", "onUpdate:modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_v_text_field, {
                    modelValue: rule.dutyValue,
                    "onUpdate:modelValue": ($event: any) => ((rule.dutyValue) = $event),
                    onInput: ($event: any) => (rule.dutyValue = $event.target.value.replace(/\,/g, '')),
                    placeholder: "Valor/hora",
                    variant: "outlined",
                    density: "comfortable",
                    "hide-details": "auto",
                    class: "w-full min-w-[140px]",
                    color: "primary",
                    type: "number",
                    error: !!_ctx.errors?.[`rules[${index}].dutyValue`],
                    "error-messages": _ctx.errors?.[`rules[${index}].dutyValue`]
                  }, {
                    "prepend-inner": _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onInput", "error", "error-messages"])
                ]),
                _createVNode(_component_v_tooltip, { text: "Duplicar regra" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_icon, _mergeProps(props, {
                      icon: _unref(mdiContentCopy),
                      size: "20",
                      class: "cursor-pointer text-primary hover:text-primary5",
                      onClick: ($event: any) => (_ctx.copyRule(index))
                    }), null, 16, ["icon", "onClick"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_tooltip, { text: "Excluir regra" }, {
                  activator: _withCtx(({ props }) => [
                    (_ctx.rules.length > 1)
                      ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                          icon: _unref(mdiTrashCan),
                          size: "20",
                          class: "cursor-pointer text-red-500 hover:text-red-700",
                          onClick: ($event: any) => (_ctx.confirmDelete(index))
                        }), null, 16, ["icon", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              (_ctx.showAntecipeRule)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "m-0 pb-3 text-right text-xs text-neutral50",
                    "data-testid": `payment-rule-antecipe-rule-help-${index}`
                  }, " Vale só para plantão antecipado, a partir da data de corte. Padrão = Proporcional com limite; exceção aprovada continua valendo acima desta regra. ", 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 64))
      : (_openBlock(), _createBlock(EmptyList, {
          key: 1,
          title: "Nenhuma política de pagamento encontrada"
        }))
  ]))
}
}

})